"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _framerMotion = require("framer-motion");

var _Flex = _interopRequireDefault(require("../../Flex/Flex"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

var _MotionFlex = _interopRequireDefault(require("../../motionComponents/MotionFlex/MotionFlex"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var UserInterfaceNotification = function UserInterfaceNotification(_ref) {
  var notification = _ref.notification,
      removeNotification = _ref.removeNotification,
      index = _ref.index;
  return /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
    width: "auto",
    height: "auto",
    alignItems: "center",
    maxWidth: "70vw",
    justifyContent: "space-between",
    position: "absolute",
    borderRadius: 10,
    initial: {
      y: 200
    },
    animate: {
      y: -Math.abs(index * 100),
      transition: {
        delay: index * 0.05,
        type: "spring",
        bounce: 0.25
      }
    },
    exit: {
      y: 200,
      transition: {
        type: "spring",
        bounce: 0.2,
        duration: 0.5 + index * 0.1
      }
    },
    bg: "#707070e3",
    p: 3,
    m: 2
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    width: "auto",
    fontSize: 18,
    color: "light.0"
  }, notification.message), notification.action && /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
    ml: 4,
    whileHover: {
      scale: 1.1,
      cursor: "pointer"
    },
    onTap: notification.action
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: notification.icon,
    color: "light.0"
  })), notification.closable && /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
    ml: 4,
    whileHover: {
      scale: 1.1,
      cursor: "pointer"
    },
    onTap: function onTap() {
      return removeNotification({
        id: notification.id
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "close",
    color: "light.0"
  })));
};

var UserInterfaceNotifications = function UserInterfaceNotifications(_ref2) {
  var notificationData = _ref2.notificationData,
      removeNotification = _ref2.removeNotification;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    mt: 5,
    zIndex: 99999999999,
    position: "relative",
    style: {
      position: "fixed",
      bottom: 50
    }
  }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, notificationData.map(function (notification, index) {
    return /*#__PURE__*/_react["default"].createElement(UserInterfaceNotification, {
      key: notification.id,
      index: index,
      notification: notification,
      removeNotification: removeNotification
    });
  })));
};

var _default = UserInterfaceNotifications;
exports["default"] = _default;